// "Done" was previously written by the "Update to Completed" action and is treated as "Completed".
const COMPLETED_STATUSES = ["Completed", "Done"];

const isCompletedStatus = (status) => COMPLETED_STATUSES.includes(status);

export default isCompletedStatus;
